import React from 'react';
import { SkeletonValue } from './SkeletonValue';

const STAT_LABELS = ['Chicas', 'Planes', 'Hoy'] as const;

const CityStatsSkeleton: React.FC = () => {
  return (
    <div
      className="max-w-xl mx-auto mb-10"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Cargando estadísticas"
    >
      <div className="grid grid-cols-3 gap-0 overflow-hidden rounded-2xl border border-[rgba(74,33,71,0.1)] bg-chisme-bg">
        {STAT_LABELS.map((label, i) => (
          <div
            key={label}
            className={`px-3 py-3.5 sm:px-4 sm:py-4 text-center ${
              i < 2 ? 'border-r border-[rgba(74,33,71,0.1)]' : ''
            }`}
          >
            <p className="font-jetbrains text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[#5a3158] leading-tight">
              {label}
            </p>
            <div className="mt-1 flex justify-center">
              <SkeletonValue
                className={`h-6 sm:h-7 ${
                  label === 'Hoy' ? 'w-8' : label === 'Chicas' ? 'w-14 sm:w-16' : 'w-10'
                }`}
              />
            </div>
          </div>
        ))}
      </div>
      <span className="sr-only">Cargando estadísticas…</span>
    </div>
  );
};

export default CityStatsSkeleton;
